import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterItem } from '../models/filter';
import { ICheckingStrategy } from '../models/strategy';
import { Utils } from '../../../services/utils.service';
import { Observable } from 'rxjs';

import { SHARED_MODULES } from '../../../../shared.';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-tree-radio',
    templateUrl: './tree-radio.component.html',
    styleUrls: ['./tree-radio.component.scss'],
	imports: [SHARED_MODULES, FaIconComponent],
    standalone: true
})
export class TreeRadioComponent implements OnInit {

	@Input('element') element: FilterItem;
	@Input('checkingStrategy') set selectStrategy(value: ICheckingStrategy) {
		this.strategy = value.getKey(this.element.id as number);
		this.checkingStrategy = value;
	};
	@Input('loadChildren') loadChildren: (id?: number) => Observable<Array<FilterItem>>;
	@Output('check') check: EventEmitter<void> = new EventEmitter<void>();

	strategy: { checked: boolean, indeterminate: boolean };
	checkingStrategy: ICheckingStrategy;
	count: number = 100;

	constructor() {}

	ngOnInit() {}

	async onToggle(element: FilterItem) {
		if (element.opened) {
			element.opened = false;
			Utils.rec<FilterItem>(element.children, ((child: FilterItem) => child.opened = false));
			return;
		}

		if (element.hasOwnProperty('children') && Array.isArray(element.children) && element.children.length) {
			element.opened = true;
			return;
		}

		if (this.loadChildren) {
			element.loading = true;
			const checkingStrategy = this.checkingStrategy;
			this.loadChildren(element.id as number).subscribe({
				next(children: Array<FilterItem>) {
					children.forEach((item: FilterItem) =>
						checkingStrategy.setKey(
							item.id as number,
							checkingStrategy.getKey(item.id as number).checked,
							false
						)
					);
					element.children = children
					element.loading = false;
					element.opened = true;
				},
				error() {
					element.children = [];
					element.loading = false;
				}
			});
		}
	}

	onChange(element: FilterItem): void {
		const strategy: { checked: boolean, indeterminate: boolean } = this.checkingStrategy.getKey(element.id as number),
			checked = !strategy.checked;

		this.checkingStrategy.clear();
		strategy.checked = checked;
		this.check.emit();
	}

	showMore(): void {
		this.count += 100;
	}
}
